import { useMemo } from 'react'

import { KIND_SEARCHABLE_FILTER_WORD } from '@constants'
import { GETAllVariables, GETVariableDTO } from '@types'

// Функция замены НАЗВАНИЯ переменной на ЗНАЧЕНИЕ переменной в фильтре
export const replaceVariablesInFilter = (
  template: string,
  scope: string,
  vars: GETAllVariables | undefined
): string => {
  return (vars || []).reduce((result, { title, defaultValue, value }) => {
    const token = `${scope}.${title}`

    let variableValue = value ?? defaultValue ?? `'null'`
    variableValue = variableValue === '' ? `'null'` : variableValue

    const wrapperVariableValue =
      typeof variableValue === 'string' && variableValue.includes(' ')
        ? `'${variableValue}'`
        : variableValue

    return result.includes(token) ? result.replaceAll(token, wrapperVariableValue) : result
  }, template)
}

export const useReplaceVariablesInFilter = ({
  rawFilter = '',
  searchableFilterWord,
  latestVariables,
  globalVariables,
}: {
  rawFilter: string | undefined | null
  searchableFilterWord: KIND_SEARCHABLE_FILTER_WORD
  latestVariables?: GETVariableDTO[]
  globalVariables: GETAllVariables
}) => {
  const filter = rawFilter ?? ''

  // Новый фильтр в котором заменили значения переменных для нужных областей видимостей
  const newFilter = useMemo(() => {
    if (!filter) {
      return ''
    }

    let updated = replaceVariablesInFilter(filter, searchableFilterWord, latestVariables)

    updated = replaceVariablesInFilter(updated, 'global', globalVariables)

    return updated.includes(`'null'`) ||
      updated.includes('global.') ||
      updated.includes(`${searchableFilterWord}.`)
      ? ''
      : updated
  }, [filter, latestVariables, globalVariables, searchableFilterWord])

  return {
    updatedFilter: newFilter,
  }
}
